import React from 'react';

export const ArrowFullIcon = (props) => {
  return (
    <svg viewBox='0 0 10 10' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/arrow' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='bx:bxs-down-arrow'>
          <rect id='ViewBox' x='0' y='0' width='9.15808105' height='9.15808105'></rect>
          <path
            d='M4.43462043,7.73598822 C4.50911908,7.84418846 4.63207889,7.90881443 4.76344608,7.90881443 C4.89481328,7.90881443 5.01777308,7.84418846 5.09227173,7.73598822 L8.69255259,2.53558254 C8.77749518,2.41332114 8.78743647,2.25397853 8.71834905,2.1221073 C8.64926164,1.99023607 8.51259949,1.90769909 8.36372694,1.90793308 L1.16316522,1.90793308 C1.0146682,1.90854695 0.878678822,1.991208 0.80976518,2.12274755 C0.740851538,2.25428709 0.750307836,2.41314721 0.834339571,2.53558254 L4.43462043,7.73598822 Z'
            id='Path'
            fill='currentColor'
            fillRule='nonzero'
          ></path>
        </g>
      </g>
    </svg>
  );
};
